// Mirror of worker/src/lib/template-kinds.ts. Frontend can't import
// across the worker/ ↔ frontend/ boundary so the two files are kept
// in sync by hand. If you change one, change the other.

export const TEMPLATE_KINDS = [
  "quarterly_availability",
  "welcome_web_terminal",
  "volunteer_portal_invite",
  "schedule_share",
  "availability_laggard",
  "kiosk_reminder",
] as const;

export type TemplateKind = (typeof TEMPLATE_KINDS)[number];

export interface TemplateKindMeta {
  label: string;
  blurb: string;
}

export const TEMPLATE_KIND_META: Record<TemplateKind, TemplateKindMeta> = {
  quarterly_availability: {
    label: "Quarterly availability email",
    blurb:
      "Send before each new scheduling cycle. Ask volunteers to enter their conflict dates.",
  },
  welcome_web_terminal: {
    label: "Welcome to Web Terminal",
    blurb: "Onboarding email for new volunteers' MSP accounts.",
  },
  volunteer_portal_invite: {
    label: "Sacristy account invitation",
    blurb:
      "Invite volunteers to create their Sacristy account — signing up with the email MSP has on file.",
  },
  schedule_share: {
    label: "Here's your schedule",
    blurb: "Sends volunteers a copy of their personal schedule.",
  },
  availability_laggard: {
    label: "Availability reminder",
    blurb: "Gentle nudge to volunteers who haven't entered conflicts yet.",
  },
  kiosk_reminder: {
    label: "Kiosk reminder",
    blurb: "Ask volunteers to start using the parish kiosk.",
  },
};

// URL-hash slug for a kind: underscores → hyphens. Used by deep
// links from the dashboard ("Open templates" attention card →
// /templates#quarterly-availability).
export function hashFor(kind: TemplateKind): string {
  return kind.replace(/_/g, "-");
}

export function kindFromHash(hash: string): TemplateKind | null {
  const stripped = hash.replace(/^#/, "");
  const restored = stripped.replace(/-/g, "_");
  return (TEMPLATE_KINDS as readonly string[]).includes(restored)
    ? (restored as TemplateKind)
    : null;
}
